import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEntityModel} from "../custom-object-entity.model";
import {ProductLineCustomObjectSearchModel} from "../product-line-custom-object-search.model";
import {CustomObjectSearchPageComponent} from "./custom-object-search-page.component";

@Component({
    selector: "wbo-product-line-custom-object-search-page",
    templateUrl: "custom-object-search-page.component.html",
    providers: [provideSearchModel(ProductLineCustomObjectSearchModel), provideEntityModel(CustomObjectEntityModel)]
})
export class ProductLineCustomObjectSearchPageComponent extends CustomObjectSearchPageComponent {
    override productLineContext: boolean = true;

    constructor(searchModel: ProductLineCustomObjectSearchModel) {
        super(searchModel);
    }
}
